import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export const HowItWorks = () => {
    const { t } = useLang();
    return (
        <section
            id="how"
            data-testid="how-section"
            className="relative py-14 sm:py-20 overflow-hidden"
        >
            <div className="absolute inset-0 diagonal-stripes opacity-50" />
            <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[var(--primary)]/10 blur-[120px] rounded-full" />

            <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
                    <div>
                        <span className="font-display text-[var(--primary)] text-sm tracking-[0.3em]">
                            {t.how.eyebrow}
                        </span>
                        <h2 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-black leading-tight">
                            {t.how.h2Top}{" "}
                            <span className="text-gradient-orange">{t.how.h2Bottom}</span>
                        </h2>
                    </div>
                    <p className="max-w-md text-neutral-400 text-base sm:text-lg leading-relaxed">
                        {t.how.desc}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {t.how.steps.map((s, i) => (
                        <motion.div
                            key={s.n}
                            data-testid={`step-${s.n}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.12 }}
                            className="card-dark rounded-2xl p-8 relative group overflow-hidden"
                        >
                            <span className="absolute top-4 left-4 font-display text-[120px] sm:text-[140px] leading-none text-white/[0.04] group-hover:text-[var(--primary)]/20 transition-colors">
                                {s.n}
                            </span>
                            <div className="relative">
                                <span className="font-display text-3xl text-[var(--primary)] tracking-widest">
                                    {s.n}
                                </span>
                                <h3 className="mt-4 text-2xl sm:text-3xl font-bold text-white">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-neutral-400 leading-relaxed">
                                    {s.desc}
                                </p>
                                <div className="mt-6 w-12 h-[2px] bg-[var(--primary)] group-hover:w-24 transition-all" />
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
